// toast.js
import Vue from 'vue';
const bus = new Vue();

const ToastPlugin = {
  install(Vue) {
    Vue.prototype.$toast = {
      show(message, type = 'info', duration = 3000, key = null) {
        bus.$emit('toast', { message, type, duration, key });
      }
    };
    Vue.mixin({
      created() {
        this.$toastBus = bus;
      }
    });
  }
};

export default ToastPlugin;
